import { DISABLED_OPACITY } from "../../../../styles/colors/consts";
import { Display } from "../../../../types";
import { ResponsiveProp } from "../../../../utils/responsiveProps";

export default function getMiscStyleProps({
  width,
  fillHeight,
  accessibilityLabel,
  disabled,
  loading
}: {
  width: ResponsiveProp<string | undefined>;
  fillHeight: boolean;
  disabled: boolean;
  loading: boolean;
  accessibilityLabel?: string;
}) {
  return {
    display: "block" as ResponsiveProp<Display>,
    width,
    height: fillHeight ? "100%" : undefined,
    "aria-label": accessibilityLabel,
    fontWeight: "bold" as ResponsiveProp<"bold" | "normal">,
    textDecoration: "none",
    cursor: disabled ? "not-allowed" : loading ? "progress" : "pointer",
    opacity: disabled ? DISABLED_OPACITY : "1"
  };
}
